import { cn } from '@workspace/lib';
import Link from 'next/link';
import { Icon, Picture, TextButton, Typography } from '@workspace/ui/common';
import { BinOptionItemProps } from '../binOptions.types';

export function BinOptionItem({ item, hyperlinkText = 'Get a Quote', className = '' }: BinOptionItemProps) {
  const href = item?.quoteBin ? `/quote?bin=${encodeURIComponent(item.quoteBin)}` : '/quote';

  return (
    <Link href={href} className={cn('max-h-132 border border-secondary-100 rounded-md group', className)}>
      <div className="image-container bg-white h-72.5 rounded-t-md overflow-hidden">
        {item?.image && (
          <Picture
            image={item.image}
            alt={item?.image?.bynderImage?.alt || item?.image?.alt || item?.title || ''}
            desktopWidth={384}
            desktopHeight={290}
            imgClassName="object-cover w-full h-full rounded-t-md transition-transform duration-300 ease-in-out group-hover:scale-[1.03]"
          />
        )}
      </div>

      <div className="py-md px-sm flex flex-col gap-lg rounded-b-md md:min-h-59.5 justify-between md:gap-0 h-59.5">
        <div className="flex flex-col gap-xs">
          <Typography
            variant="h4"
            className="text-secondary-400 line-clamp-3 font-semibold! md:font-bold! text-lg!"
            title={item?.title}
            styleVariant="h6"
          >
            {item?.title}
          </Typography>

          <Typography
            variant="h6"
            className="text-secondary-500 line-clamp-3 font-body h-fit leading-5 font-semibold"
            title={item?.subtitle}
          >
            {item?.subtitle}
          </Typography>
        </div>

        {/* Actions */}
        <div className="flex items-center justify-end gap-4">
          <div className="flex items-center gap-1">
            <TextButton
              isDisabled={false}
              className="bg-transparent p-0 font-semibold! text-primary hover:no-underline!"
            >
              {hyperlinkText}
            </TextButton>
            <Icon
              name="arrowRightIcon"
              size={24}
              className="text-primary transition-transform duration-300 ease-in-out group-hover:translate-x-1"
            />
          </div>
        </div>
      </div>
    </Link>
  );
}
